import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DrawerService {
  state = signal(false);
}
